import { render, staticRenderFns } from "./internationalServerProductList.vue?vue&type=template&id=c1d13d4e&scoped=true"
import script from "./internationalServerProductList.vue?vue&type=script&lang=js"
export * from "./internationalServerProductList.vue?vue&type=script&lang=js"
import style0 from "./internationalServerProductList.vue?vue&type=style&index=0&id=c1d13d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d13d4e",
  null
  
)

export default component.exports